// extracted by mini-css-extract-plugin
module.exports = {"checkout-item":"checkoutItem_checkout-item__wsw_G","image":"checkoutItem_image__N6B0W","price":"checkoutItem_price__z_xVu"};